import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';

import tournamentService from "../../../api/tournament.service";
import { DEFAULT_MASTER_DRAWER_WIDTH } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import CustomTableSearch from "../../common/CustomTableSearch";
import TournamentEntry from "./TournamentEntry";



const TournamentList = () => {

  const dispatch = useDispatch();  
  const state = useSelector((state)=>state.tournament)
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  

  const [visible, setVisible] = useState(false);
  const [tournamentList, setTournamentList] = useState([]);
  const [tournamentData, setTournamentData] = useState({
    tournament_id: 0,
    tournament_name:'',
    venue:'',
    tournament_start_date: '',
    tournament_end_date: '',
});

  const showDrawer = (rowdata) => {  
 //   setProgrammeCommercialData(_);    

 setTournamentData({
      tournament_id: rowdata.tournament_id,
      tournament_name:rowdata.tournament_name,
      venue:rowdata.venue,
      tournament_start_date: rowdata.tournament_start_date,
      tournament_end_date: rowdata.tournament_end_date, 
      mode: "EDIT"
  })
    setVisible(true);
  };


  const onClose = () => {
    setVisible(false);
  };
 
  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Tournament Name',
      dataIndex: 'tournament_name',
      key: 'tournament_name',
      sorter: (a, b) => a.tournament_name.localeCompare(b.tournament_name),
    },
    {
      title: 'Venue',
      dataIndex: 'venue',
      key: 'venue',
      sorter: (a, b) => a.venue.localeCompare(b.venue),
    },
    {
      title: 'Start Date',
      dataIndex: 'tournament_start_date',
      key: 'tournament_start_date',
     // sorter: (a, b) => a.tournament_start_date.localeCompare(b.tournament_start_date),
    },   
    // {
    //   title: 'Starting Affiliation Year',
    //   dataIndex: 'starting_affiliation_year',
    //   key: 'starting_affiliation_year',
    //   render: (text, record) => `${record.start_year} - ${record.end_year}`,      
    // }, 
    {
        title: 'End Date',
        dataIndex: 'tournament_end_date',
        key: 'tournament_end_date',       
    },   
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    tournamentService.list().then((res) => {
      setTournamentList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [state.tournament])


  const onSearch = (e) => {
    const searchString = e.target.value.toLowerCase();
    const filteredList = tournamentList.filter(data => {       
        const startingAffiliationYear = `${data.start_year}-${data.end_year}`;      
        const isStartingAffiliationYearMatch = startingAffiliationYear.toLowerCase().includes(searchString);       
        const dataString = JSON.stringify(data).toLowerCase();       
        const isDataStringMatch = dataString.includes(searchString);    
        return isStartingAffiliationYearMatch || isDataStringMatch;
    });
    setFilteredSearchList(filteredList);
}

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch}  />
      <Table 
        columns={columns} 
        rowKey='tournament_id' 
        dataSource={filteredSearchList} 
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
        />

      <Drawer
          title="Edit Tournament"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <TournamentEntry data={tournamentData} onDrawerClose={onClose}   />
        </Drawer>

    </>
  );
};

export default TournamentList;